import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiCenter } from '../../api/ApiCenter';
import { Button, Form, Input, Popconfirm, Radio } from 'antd';
import classes from './style.css/ChangeAttestation.module.css';
import { DeleteOutlined } from '@ant-design/icons';
import notification, { NotificationPlacement } from 'antd/lib/notification';
import { UI_Footer } from '../../../Core/Core';
interface ApiResponse {
  success: boolean;
  data: Question[];
}

interface Question {
  id: number;
  category_id: number;
  text: string;
  answers: Answer[];
}

interface Answer {
  id: number;
  question_id: number;
  is_right: boolean;
  text: string;
}
interface ResultObject {
  question_title: string;
  question_id: number;
  questions_1: string;
  answers_1: number;
  questions_2: string;
  question_button: string;
  answers_2: number;
  questions_3: string;
  answers_3: number;
  questions_4: string;
  answers_4: number;
}
const ChangeAttestation = () => {
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const ApiStart = new ApiCenter();
  const [form] = Form.useForm();
  const openNotification = (
    placement: NotificationPlacement,
    error: boolean,
    textEror?: string
  ) => {
    if (error) {
      notification.error({
        message: `Упс что то пошло не так (─‿‿─)♡`,
        description: textEror,
        placement,
      });
    } else {
      notification.success({
        message: `Тест Успешно изменен (＠＾◡＾)`,
        placement,
      });
    }
  };

  const getTestAttestationData = async (id: string | undefined) => {
    await ApiStart.GET_API(`hr/attestation/${id}`, 'GET').then((response: ApiResponse) => {
      if (response.success) {
        if (response.data) {
          // form.setFieldValue('title', response.data.title);
          // form.setFieldValue('test_id', response.data.id);
          // const object3 = { id: response.data.id };

          const newData = response.data.map((item) => {
            const object1 = {
              question_title: item.text,
              question_id: item.id,
            };
            const object2 = item.answers
              .sort((a, b) => a.id - b.id)
              .reduce((acc: any, i: any, index: number) => {
                const fun = (bol: boolean) => {
                  if (bol) {
                    return `questions_${index + 1}`;
                  }
                };
                if (typeof fun(i.is_right) === 'string') {
                  acc[`questions_${index + 1}`] = i.text;
                  acc.question_button = fun(i.is_right);
                  acc[`answers_${index + 1}`] = i.id;
                } else {
                  acc[`questions_${index + 1}`] = i.text;
                  acc[`answers_${index + 1}`] = i.id;
                }
                return acc;
              }, {});
            const result: ResultObject = Object.assign({}, object1, object2);
            return result;
          });
          form.setFieldValue('questions', newData);
        }
      }
    });
  };

  useEffect(() => {
    if (id) {
      getTestAttestationData(id);
    }
  }, [id]);

  const onFinish = async (value: any) => {
    setIsSubmitting(true);
    // нужно добавить ключи и проверку на правильнный ответ
    const objresult = (objs: any) => {
      const newArray: any[] = objs
        .map((obj: any) => {
          let pairs: any;
          if (obj?.question_id) {
            pairs = {
              id: obj?.question_id,
              text: obj?.question_title,
              answers: [],
            };
          } else {
            pairs = {
              text: obj?.question_title,
              answers: [],
            };
          }
          //answers

          for (const key in obj) {
            if (key.includes('questions_') && obj.hasOwnProperty(key)) {
              const questionNumber = key.split('_').pop();
              const questionKey = `questions_${questionNumber}`;
              const answerKey = `answers_${questionNumber}`;
              const fun = () => {
                const chek = obj.question_button;
                if (chek === questionKey) {
                  return true;
                } else {
                  return false;
                }
              };
              if (obj.hasOwnProperty(answerKey)) {
                const pair: any = {
                  question_id: obj?.question_id,
                  text: obj[questionKey],
                  id: obj[answerKey],
                  is_right: fun(),
                };
                pairs.answers.push(pair);
              } else if (
                obj.hasOwnProperty(answerKey) === false &&
                obj.hasOwnProperty(questionKey) === true
              ) {
                const pair: any = {
                  text: obj[questionKey],
                  is_right: fun(),
                };
                pairs.answers.push(pair);
              }
            }
          }

          return pairs;
        })
        .flat();
      return newArray;
    };
    const returnApi = {
      questions: objresult(value.questions),
    };
    await ApiStart.GET_API(`hr/attestation/${id}`, 'PUT', returnApi).then((res: any) => {
      if (res.success) {
        openNotification('top', false);
        getTestAttestationData(id);
      } else {
        openNotification('top', true, res.message);
      }
    });
    setTimeout(() => {
      setIsSubmitting(false);
    }, 1000);
  };

  // if (data?.length === 0) {
  //   return <>Нет данных</>;
  // }
  return (
    <>
      {' '}
      <Form form={form} name="attestation" onFinish={onFinish} autoComplete="off" layout="vertical">
        {/* <Form.Item label="Название Теста" name="title" style={{ width: 450 }}>
          <Input />
        </Form.Item>
        <Form.Item label="id Теста" name="test_id" style={{ width: 450 }}>
          <Input disabled={true} />
        </Form.Item> */}
        <Form.List name="questions">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index: number) => {
                const confirmDeleteLesson = () => {
                  // remove(name);
                  const { question_id } =
                    form.getFieldValue('questions')[key] !== undefined
                      ? form.getFieldValue('questions')[key]
                      : false;
                  if (question_id) {
                    ApiStart.GET_API(`hr/attestation/${question_id}`, 'DELETE').then((r) => {
                      if (r.success) {
                        openNotification('top', false);
                        remove(name);
                      } else {
                        openNotification('top', true, r.message);
                      }
                    });
                  } else {
                    remove(name);
                  }
                };
                return (
                  <React.Fragment key={key}>
                    <div className={classes.WrapperLissensIndex}>
                      <h1>Вопрос {index + 1}</h1>
                      <div>
                        <Popconfirm
                          placement="right"
                          title={'Удалить урок ?'}
                          onConfirm={confirmDeleteLesson}
                          okText="Да удалить вопрос"
                          cancelText="Отмена"
                        >
                          <Button>
                            Удалить вопрос <DeleteOutlined />
                          </Button>
                        </Popconfirm>
                      </div>
                    </div>
                    <Form.Item
                      {...restField}
                      name={[name, 'question_title']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                      label="Описание вопроса"
                    >
                      <Input placeholder="Описание вопроса" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_1']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                      label="Варианты ответов"
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_2']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_3']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>{' '}
                    <Form.Item
                      {...restField}
                      name={[name, 'questions_4']}
                      // rules={[{ required: true, message: 'Введите название урока' }]}
                    >
                      <Input.TextArea placeholder="Вариант ответа" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'question_button']}
                      label="Выберете правильный ответ"
                      rules={[{ required: true, message: 'Выберете правильный ответ!!!!!!!' }]}
                    >
                      <Radio.Group>
                        <Radio.Button value="questions_1">Вариант 1</Radio.Button>
                        <Radio.Button value="questions_2">Вариант 2</Radio.Button>
                        <Radio.Button value="questions_3">Вариант 3</Radio.Button>
                        <Radio.Button value="questions_4">Вариант 4</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </React.Fragment>
                );
              })}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block>
                  + Добавить вопрос
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <UI_Footer classStyle="end">
          <Form.Item style={{ margin: '0' }}>
            <Button type="primary" htmlType="submit" loading={isSubmitting} disabled={isSubmitting}>
              сохранить
            </Button>
          </Form.Item>
        </UI_Footer>
      </Form>
    </>
  );
};

export default ChangeAttestation;
